/* import __COLOCATED_TEMPLATE__ from './navigation-view.hbs'; */
import Component from '@ember/component';
export default Component.extend({
  tagName: ''
});